import { observer } from 'mobx-react'
import React, { useState } from 'react'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { isDealerWE } from '../../../../../services/AccountService'
import { getCollections } from '../../../../SingleRequestPage/components/SingleRequestDrawer/helpers/getCollections'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import CustomerInfoContent from './CustomerInfoContent'
import EditFullCustomerInfo from './EditFullCustomerInfo'
import EditPartialCustomerInfo from './EditPartialCustomerInfo'

interface NewCustomerDataAccProps {
  request: RequestType
}

const NewCustomerDataAcc: React.FC<NewCustomerDataAccProps> = ({ request }) => {
  const [editMode, setEditMode] = useState<'full' | 'partial' | null>(null)

  const onEdit = () => {
    if (editMode) {
      setEditMode(null)
      return
    }

    if (
      request.status === 14 ||
      (request.status === 6 && request.dataCheckingStatus === 2)
    ) {
      setEditMode('full')
      return
    }

    setEditMode('partial')
  }

  const { localityIdx, districts } = getCollections(
    request.territory,
    request.district,
    request.locality,
    request.reasonId,
  )

  const withFullDotationLocalities = districts[localityIdx]?.Localities?.filter(
    (el: any) => el.AllowedFinancialSourceIds.includes(1),
  )?.map((el: any) => el.Name)

  const isAllowedAndFullDotation =
    request.financialSourceId === 1 &&
    withFullDotationLocalities.includes(request.locality)

  const dealerWEEdit =
    [2, 4, 5].includes(request.status) &&
    isAllowedAndFullDotation &&
    isDealerWE()
  const dealerEdit = [2, 4, 5].includes(request.status) && !isDealerWE()
  const canEditNotReport = dealerWEEdit || dealerEdit

  const canEditData =
    canEditNotReport ||
    request.status === 14 ||
    (request.status === 6 && request.dataCheckingStatus === 2)

  return (
    //  @ts-ignore
    <CustomAccordion
      onEdit={canEditData && onEdit}
      defaultOpenState
      summary={'Данные абонента'}
    >
      {!editMode && <CustomerInfoContent request={request} />}
      {editMode === 'full' && (
        <EditFullCustomerInfo request={request} onClose={onEdit} />
      )}
      {editMode === 'partial' && (
        <EditPartialCustomerInfo
          request={request}
          onClose={onEdit}
          isAllowedAndFullDotation={isAllowedAndFullDotation}
        />
      )}
    </CustomAccordion>
  )
}

export default observer(NewCustomerDataAcc)
